export default __webpack_public_path__ + "static/media/web.1b336ad8.jpg";